<template>
    <div>
        <v-navigation-drawer v-model="primaryMenu" fixed temporary>
            <v-list>
                <v-list-item dense v-for="item in selectedPrimary" :key="item.id" link @click="item.action">
                    <MenuItem :item="item" />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import MenuItem from './MenuItem.vue'
export default {
    components: {
        MenuItem
    },
    computed: {
        // 1階層目メニュー
        selectedPrimary() {
            return this.primaryMenuItems.filter(
                (item) => {
                    return (
                        (item.id == 0 && this.$root.moshiActiveFlg == true) ||
                        (item.id == 1 && (this.$root.testResultActiveFlg == true || this.$root.reportPublishActiveFlg == true)) ||
                        (item.id >= 2)
                    )
                }
            );
        },
    },
    data() {
        return {
            primaryMenu: false,

            primaryMenuItems: [
                {
                    id: 0,
                    icon: "mdi-file-document-multiple-outline",
                    name: "模試のきろく",
                    text: "",
                    action: this.toPracticeExamHistory,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 1,
                    icon: "mdi-file-document-multiple-outline",
                    name: "成績情報",
                    text: "",
                    action: this.toRegularExamHistory,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 4,
                    icon: "mdi-card-account-mail",
                    name: "メールアドレス設定",
                    action: this.toProfileSetting,
                    subMenuFlg: false,
                    pattern: 1,
                },
                {
                    id: 99,
                    icon: "mdi-note-text-outline",
                    name: "利用規約",
                    action: this.toTermsOfService,
                    subMenuFlg: false,
                    pattern: 1,
                },
            ],
        }
    },
    methods: {
        openDrawer() {
            this.primaryMenu = true;
        },
        // プロフィール設定画面
        toProfileSetting() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "ProfileSetting",
            });
        },
        // 模試のきろく
        toPracticeExamHistory() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "PracticeExamHistory",
            });
        },
        // 成績情報
        toRegularExamHistory() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "RegularExamHistory",
            });
        },
        // 利用規約確認画面
        toTermsOfService() {
            this.$emit('changeActiveFlg', undefined);
            this.$router.push({
                name: "TermsOfService",
            });
        },
    }
}
</script>